import type { CampaignEditorFields, CampaignEditorState } from './types';

export const initialFields: CampaignEditorFields = {
  headingFont: 'Arial',
  bodyFont: 'Arial',
  salutation: '',
  title: '',
  startIntro: '',
  cta: '',
  mainImage: '',
  headingImage: '',
  description: '',
  backgroundColor: '',
  containerColor: '',
  bodyTextColor: '',
  headingTextColor: '',
  accentColor: '',
  secondaryAccentColor: '',
  secondaryBackgroundColor: '',
  buttonTextColor: '',
  themeColorPackId: undefined,
  themeMode: undefined,
  hideBrandliveLogo: false,
};

export const initialState: CampaignEditorState = {
  campaignUuid: null,
  language: null,
  baseLanguage: 'en',
  templateId: undefined,
  initialized: false,
  templateMounted: false,
  fields: initialFields,
  blocks: null,
  selectedBlockId: null,
};
